import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Box,
  Chip,
  OutlinedInput,
} from "@mui/material";
import UserHeader from "./OrganizationAdminHeader";
import UserTable from "./OrganizationAdminTable";
import {
  fetchUsers,
  updateUserStatus,
  CreateUserFromAdmin,
  AssignRoleToUser,
  createUser,
  FetchRoles,
} from "../../Services/usersService";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import OrganizationService from "../../Services/OrganizationService";
import UsertoOrganizationService from "../../Services/UsertoOrganizationService";
import UsertoProjectService from "../../Services/UsertoProjectService";
import ProjectService from "../../Services/ProjectService";
import UsertoModuleService from "../../Services/UsertoModuleService";
import { useAuth } from "../../Services/AuthContext";
import ModuleService from "../../Services/ModuleService";
import NotificationService from "../../Services/NotificationService";

export default function OrganizationAdminDash() {
  const { user, loading: authLoading } = useAuth();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [openCreate, setOpenCreate] = useState(false);

  const [loadingCreate, setLoadingCreate] = useState(false);
  const [roles, setRoles] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [organization, setOrganization] = useState([]);

  const [projects, setProjects] = useState([]);
  const [loadingProjects, setLoadingProjects] = useState(false);

  const [modules, setModules] = useState([]);
  const [loadingModules, setLoadingModules] = useState(false);


  const organizationIds = user?.organizationIds || [];

  const [createForm, setCreateForm] = useState({
    username: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    role: "",
    org: [],
    projects: [],
    modules: []
  });

  // const [org ,setOrg] = useState([]);

  useEffect(() => {
    if (authLoading || !user) return;
    loadUsers();
    featchedRoles();
    fetchOrganization();
  }, [authLoading, user]);

  const loadUsers = async () => {
    try {
      setLoading(true);
      const res = await fetchUsers();
      setUsers(Array.isArray(res) ? res : res?.data || []);
    } catch (err) {
      setError("Failed to load users");
    } finally {
      setLoading(false);
    }
  };

  const handleOpenCreate = () => setOpenCreate(true);
  const handleCloseCreate = () => setOpenCreate(false);

  const handleSearch = (query) => {
    setSearchQuery(query || "");
  };

  // handle form input
  const handleCreateChange = (e) => {
    const { name, value } = e.target;

    if (name === "org") {
      let orgArray;

      // MUI returns a single value when multiple=false
      if (isMultiOrgAllowed) {
        orgArray = Array.isArray(value) ? value : [];
      } else {
        orgArray = value ? [value] : [];
      }

      setCreateForm((p) => ({
        ...p,
        org: orgArray,
        projects: [],
      }));

      fetchProjectsByOrganizations(orgArray);
      return;
    }

    if (name === "projects") {
      const projectArray = Array.isArray(value) ? value : [];

      setCreateForm((p) => ({
        ...p,
        projects: projectArray,
        modules: [],        //  reset modules
      }));

      fetchModulesByProjects(projectArray);
      return;
    }
    if (name === "modules") {
      setCreateForm((p) => ({
        ...p,
        modules: Array.isArray(value) ? value : [],
      }));
      return;
    }

    setCreateForm((p) => ({
      ...p,
      [name]: value,
    }));
  };


  const handleCreateUser = async () => {
    const { username, firstName, email } = createForm;

    if (!username || !firstName || !email) {
      alert("Please fill all required fields");
      return;
    }

    try {
      setLoadingCreate(true);

      const credentials = [
        {
          type: "password",
          value: `${createForm.username}@123`,
          temporary: false,
        },
      ];

      const safeOrgIds = createForm.org.filter((id) =>
        organizationIds.includes(id),
      );

      const attributes = {
        contact_number: createForm.phoneNumber,
        swaggerOrganizationIds: safeOrgIds.map(String),
        swaggerProjectIds: createForm.projects.map(String),
        swaggerProjectIdss: createForm.projects.map(String),
      };
      const payload = {
        username: createForm.username,
        email: createForm.email,
        firstName: createForm.firstName,
        lastName: createForm.lastName,
        enabled: true,
        emailVerified: true,
        credentials,
        attributes,
      };
      console.log("Create user payload:", payload);

      const res = await createUser(payload);
      console.log("User creation response:", res?.data?.data);
      if (res?.data?.status === 201 && res?.data?.data?.id) {
        const userId = res?.data?.data?.id;
        console.log("Created user ID:", userId);

        const roleToAssign = roles.find(
          (r) => r.id === createForm.role || r.name === createForm.role,
        );
        console.log("Assigning role:", roleToAssign?.id, roleToAssign?.name);
        if (roleToAssign?.id) {
          await AssignRoleToUser(userId, {
            id: roleToAssign.id,
            name: roleToAssign.name,
          });

          const userOrg = organization?.find(
            (o) => o.organizationId === createForm.org,
          );

          await Promise.all(
            createForm.org.map((orgId) =>
              UsertoOrganizationService.createUserToOrganization({
                userId,
                organizationId: orgId,
              }),
            ),
          );

          if (createForm.projects.length > 0) {
            await UsertoProjectService.assignProjectToUser(
              userId,
              createForm.projects,
              null,  // notificationData
              true   // isNewUser → skip GET, go straight to POST
            );
          }

          if (createForm.modules.length > 0) {
            await UsertoModuleService.createUserToModule({
              userId,
              moduleIds: createForm.modules,
            });
          }
          const orgName = organization
            .filter((o) => createForm.org.includes(o.organizationId))
            .map((o) => o.organizationName)
            .join(", ");

          NotificationService.sendCreateAccountNotification(
            createForm.email,
            createForm.username,
            orgName
          );

          //Send project assignment notification (fires after welcome)
          if (createForm.projects.length > 0) {
            const assignedProjectNames = projects
              .filter((p) => createForm.projects.includes(p.id))
              .map((p) => p.name);

            NotificationService.sendAssignProjectNotification(
              createForm.email,
              createForm.username,
              assignedProjectNames,
              orgName
            );
          }

        } else {
          console.warn(
            "No role selected or missing role id, skipping role assignment",
          );
        }
      }

      alert("User created successfully");
      handleCloseCreate();

      setCreateForm({
        username: "",
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        role: null,
        org: [],
        projects: [],
      });

      loadUsers();
    } catch (err) {
      console.error("Create user error:", err);
      const errorMsg =
        err.response?.data?.message || err.message || "Failed to create user";
      alert(errorMsg);
    } finally {
      setLoadingCreate(false);
    }
  };

  const handleStatusToggle = async (user) => {
    const newStatus = !user.enabled;

    setUsers((prev) =>
      prev.map((u) => (u.id === user.id ? { ...u, enabled: newStatus } : u)),
    );
    console.log(user.id, newStatus);

    try {
      await updateUserStatus(user.id, { enabled: newStatus });
      console.log("Updating user:", user.id, { enabled: newStatus });
    } catch (error) {
      console.error(
        "Update user error:",
        error.response?.data || error.message,
      );
    }
  };

  const featchedRoles = async () => {
    try {
      const res = await FetchRoles();
      console.log("Roles fetched:", res.data);
      const fetchedRoles = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res?.data?.data)
          ? res.data.data
          : Array.isArray(res?.data?.roles)
            ? res.data.roles
            : [];
      setRoles(fetchedRoles);
      // if (fetchedRoles.length > 0) {
      //   // store role identifier (prefer id, fallback to name) in the form for simpler comparisons
      //   setCreateForm((prev) => ({
      //     ...prev,
      //     role: fetchedRoles[0].id || fetchedRoles[0].name,
      //   }));
      // }
    } catch (error) {
      console.error("Fetch roles failed:", error);
      setError(error?.response?.data?.message || "Failed to fetch roles.");
    }
  };

  //featch all Organization
  const fetchOrganization = async () => {
    try {
      if (!organizationIds.length) {
        setOrganization([]);
        return;
      }

      const responses = await Promise.all(
        organizationIds.map((orgId) =>
          OrganizationService.getOrganizationbyid(orgId),
        ),
      );

      // Extract actual org objects
      const orgs = responses.map((res) => res?.data).filter(Boolean);

      setOrganization(orgs);

      // Auto-select org if only one
      if (orgs.length === 1) {
        setCreateForm((prev) => ({
          ...prev,
          org: [orgs[0].organizationId],
        }));
      }
    } catch (error) {
      console.error("Failed to fetch organizations", error);
      setOrganization([]);
    }
  };

  const fetchProjectsByOrganizations = async (orgIds) => {
    if (!orgIds.length) {
      setProjects([]);
      return;
    }

    try {
      setLoadingProjects(true);

      const responses = await Promise.all(
        orgIds.map((orgId) => ProjectService.getProjectsByOrganization(orgId)),
      );

      const allProjects = responses.flatMap((res) =>
        Array.isArray(res.data) ? res.data : [],
      );

      // Remove duplicates (important)
      const uniqueProjects = Array.from(
        new Map(allProjects.map((p) => [p.id, p])).values(),
      );

      setProjects(uniqueProjects);
    } catch (e) {
      console.error(e);
      setProjects([]);
    } finally {
      setLoadingProjects(false);
    }
  };

  const fetchModulesByProjects = async (projectIds) => {
    if (!projectIds.length) {
      setModules([]);
      return;
    }

    try {
      setLoadingModules(true);

      const responses = await Promise.all(
        projectIds.map((projectId) =>
          ModuleService.getModuleByProjectId(projectId)
        )
      );

      const allModules = responses.flatMap((res) =>
        Array.isArray(res.data) ? res.data : []
      );

      // remove duplicates
      const uniqueModules = Array.from(
        new Map(allModules.map((m) => [m.id, m])).values()
      );

      setModules(uniqueModules);
    } catch (err) {
      console.error("Failed to load modules", err);
      setModules([]);
    } finally {
      setLoadingModules(false);
    }
  };


  // filter users by search query (client-side)
  const displayedUsers = users.filter((u) => {
    const q = searchQuery?.trim().toLowerCase();
    if (!q) return true;
    return (
      (u.username && u.username.toLowerCase().includes(q)) ||
      (u.firstName && u.firstName.toLowerCase().includes(q)) ||
      (u.lastName && u.lastName.toLowerCase().includes(q)) ||
      (u.email && u.email.toLowerCase().includes(q))
    );
  });

  const selectedRoleObj = roles.find(
    (r) => r.id === createForm.role || r.name === createForm.role,
  );

  const isMultiOrgAllowed =
    selectedRoleObj?.name === "Super Admin" ||
    selectedRoleObj?.name === "Organization Admin";

  const isCreateDisabled =
    !createForm.role ||
    !createForm.org.length ||
    !createForm.username ||
    !createForm.email;

  return (
    <div style={{ padding: 24, paddingLeft: 50 }}>
      <UserHeader onCreateClick={handleOpenCreate} onSearch={handleSearch} />

      {loading && <p>Loading users...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}

      <UserTable users={displayedUsers} onStatusToggle={handleStatusToggle} />

      {/* CREATE USER DIALOG */}
      <Dialog
        open={openCreate}
        onClose={handleCloseCreate}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            maxHeight: "90vh",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <PersonAddIcon color="primary" />
          Create User
        </DialogTitle>

        <DialogContent dividers sx={{ overflowY: "auto" }}>
          <Grid container spacing={2} sx={{ mt: 0.5 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Username"
                name="username"
                value={createForm.username}
                onChange={handleCreateChange}
                margin="dense"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="First Name"
                name="firstName"
                value={createForm.firstName}
                onChange={handleCreateChange}
                margin="dense"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Last Name"
                name="lastName"
                value={createForm.lastName}
                onChange={handleCreateChange}
                margin="dense"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                type="email"
                value={createForm.email}
                onChange={handleCreateChange}
                margin="dense"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Phone Number"
                name="phoneNumber"
                type="number"
                value={createForm.phoneNumber}
                onChange={handleCreateChange}
                margin="dense"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth margin="dense">
                <InputLabel id="role-label">Role</InputLabel>
                <Select
                  labelId="role-label"
                  label="Role"
                  name="role"
                  value={createForm.role}
                  onChange={(e) => {
                    const selectedRole = e.target.value;

                    setCreateForm((prev) => ({
                      ...prev,
                      role: selectedRole,
                      org: [], // reset organization
                      projects: [], // reset projects
                    }));

                    setProjects([]); // clear old project list
                  }}
                >
                  <MenuItem value="">
                    <em>Select Role</em>
                  </MenuItem>

                  {roles.map((role) => (
                    <MenuItem key={role.id} value={role.id}>
                      {role.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {createForm.role && (
              <Grid item xs={12}>
                <FormControl fullWidth margin="dense">
                  <InputLabel>Organization</InputLabel>
                  <Select
                    name="org"
                    multiple={isMultiOrgAllowed}
                    value={
                      isMultiOrgAllowed
                        ? createForm.org
                        : createForm.org[0] || ""
                    }
                    onChange={handleCreateChange}
                    input={<OutlinedInput label="Organization" />}
                    renderValue={(selected) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {isMultiOrgAllowed ? (
                          selected.map((val) => {
                            const org = organization.find(
                              (o) => o.organizationId === val,
                            );
                            return (
                              <Chip
                                key={val}
                                label={org?.organizationName || val}
                              />
                            );
                          })
                        ) : (
                          <Chip
                            label={
                              organization.find(
                                (o) => o.organizationId === selected,
                              )?.organizationName || selected
                            }
                          />
                        )}
                      </Box>
                    )}
                  >
                    <MenuItem value="">
                      <em>Select Organization</em>
                    </MenuItem>

                    {organization.map((o) => (
                      <MenuItem key={o.organizationId} value={o.organizationId}>
                        {o.organizationName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}

            {createForm.org.length > 0 && (
              <Grid item xs={12}>
                <FormControl
                  fullWidth
                  margin="dense"
                  disabled={loadingProjects}
                >
                  <InputLabel>Projects</InputLabel>
                  <Select
                    name="projects"
                    multiple
                    value={createForm.projects}
                    onChange={handleCreateChange}
                    input={<OutlinedInput label="Projects" />}
                    renderValue={(selected) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {selected.map((val) => {
                          const proj = projects.find((p) => p.id === val);
                          return (
                            <Chip key={val} label={proj?.name || val} />
                          );
                        })}
                      </Box>
                    )}
                  >
                    <MenuItem value="" disabled>
                      <em>Select Projects</em>
                    </MenuItem>

                    {projects
                      .filter((p) => !createForm.projects.includes(p.id))
                      .map((p) => (
                        <MenuItem key={p.id} value={p.id}>
                          {p.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
            )}

            {createForm.projects.length > 0 && (
              <Grid item xs={12}>
                <FormControl
                  fullWidth
                  margin="dense"
                  disabled={loadingModules}
                >
                  <InputLabel>Modules</InputLabel>
                  <Select
                    name="modules"
                    multiple
                    value={createForm.modules}
                    onChange={handleCreateChange}
                    input={<OutlinedInput label="Modules" />}
                    renderValue={(selected) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {selected.map((val) => {
                          const mod = modules.find((m) => m.id === val);
                          return <Chip key={val} label={mod?.name || val} />;
                        })}
                      </Box>
                    )}
                  >
                    <MenuItem value="" disabled>
                      <em>Select Modules</em>
                    </MenuItem>

                    {modules
                      .filter((m) => !createForm.modules.includes(m.id))
                      .map((m) => (
                        <MenuItem key={m.id} value={m.id}>
                          {m.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
            )}
          </Grid>
        </DialogContent>

        <DialogActions sx={{ padding: "16px 24px" }}>
          <Button variant="outlined" onClick={handleCloseCreate}>
            CANCEL
          </Button>

          <Button
            variant="contained"
            onClick={handleCreateUser}
            disabled={isCreateDisabled || loadingCreate}
          >
            CREATE USER
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );

}

